import { http } from '../../../utils';
const controller = 'service-desk/issue-causes';
export const getIssueCauses = async (searchCondition, issueCategoryId, objectId, parentId, status) => {
    return await http.get(`${controller}/get-all`, {
        params: {
            searchCondition,
            issueCategoryId,
            objectId,
            parentId,
            status
        }
    });
};
export const getissueCause = async (id) => {
    return http.get(`${controller}/${id}`);
};
export const addIssueCause = async (issueCause) => {
    return http.post(controller, issueCause);
};
export const updateIssueCause = async (id, issueCause) => {
    return await http.put(`${controller}/${id}`, issueCause);
};
export const deleteIssueCause = async (id) => {
    return await http.delete(`${controller}/${id}`);
};
export const getIssueCausesDropdown = async () => {
    return await http.get(`${controller}/dropdown`);
};
